import React from 'react';
import styled from 'styled-components';
import { RectShape } from 'react-placeholder/lib/placeholders';
import "react-placeholder/lib/reactPlaceholder.css";

import { fetchHeatMap } from '../../redux/actions/dashboard'
import useFetch from '../../utils/useFetch';

import { HeatMap } from './'

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    margin: 15px;
`

export const HeatMapPanel = ({filterDates}) => {

    const heatMap = useFetch(fetchHeatMap, filterDates)

    const drawHeatMap = () => {
        if (heatMap.loading) { 
            return (
                <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
            )
        } else if (heatMap.response) {
            return (
                <HeatMap title="Mapa de calor" data={heatMap.response} />
            )
        }
        return null
    }
    
    return (
        <Grid>
            {drawHeatMap()}
        </Grid>
    )
}